export default window.$ = window.jQuery = require('jquery')